<script lang="ts">
    import { Component, Prop, Watch, mixins, Emit } from "vue-facing-decorator";
    import ButtonComponent from "@/components/atoms/button/Button.vue";
    import ActionButton from "@/components/atoms/action-button/ActionButton.vue";
    import {
        controlStateService,
        panelStateService,
        usePromotionStore,
        useSeatmapStore
    } from "@/domain/ticket-selection";
    import { IconName, TranslationKey } from "webshop-modules";
    import { BreakpointHandler } from "@/mixins";

    @Component({
        components: {ActionButton, ButtonComponent}
    })
    export default class MobileControls extends mixins(BreakpointHandler) {
        @Prop()
        public isPricelevelSelected!: boolean;

        @Prop()
        public actionButtonLabel!: string;

        @Emit()
        public layerExit(): boolean {
            return true;
        }

        public readonly IconName: typeof IconName = IconName;
        public readonly Translation: typeof TranslationKey = TranslationKey;
        public readonly panelState = panelStateService;
        public readonly controlState = controlStateService;
        public readonly seatmapStore = useSeatmapStore();
        public readonly promotionStore = usePromotionStore();

        public exitLevelLabel = '';

        @Watch('promotionStore.active')
        private onPromotionChange() {
            this.controlState.resetState();
        }

        private async created() {
            this.exitLevelLabel = await this.$translationService
                .getTranslationFor(this.Translation.Navigate_back_label);
        }
    }
</script>

<template>
    <div class="m-mobileControls__container">
        <div class="m-mobileControls__actionButtons">
            <div class="m-mobileControls__infoButton">
                <ActionButton :label="{key: Translation.Seatmap_action_info}"
                              :icon-name="IconName.Info"
                              v-on:clicked="panelState.activateInfoPanel()"></ActionButton>
            </div>
            <div v-bind:class="{ '-active': promotionStore.active }" class="m-mobileControls__promoButton" >
                <ActionButton v-if="promotionStore.availablePromotions.length > 0"
                              :label="{key: Translation.Seatmap_action_promo}"
                              :icon-name="IconName.Percentage"
                              v-on:clicked="panelState.activatePromotionPanel()"></ActionButton>
            </div>
            <div v-if="seatmapStore.priceLevelFilter.length"
                 v-bind:class="{'-active': isPricelevelSelected}"
                 class="m-mobileControls__filterButton">
                <ActionButton :icon-name="IconName.SmallFilter"
                              :label="{key: Translation.Seatmap_action_filter}"
                              v-on:clicked="panelState.activateFilterPanel()"></ActionButton>
            </div>
        </div>

        <div class="m-mobileControls__selectionButton">
            <button-component
                :label="actionButtonLabel"
                :active="!!seatmapStore.getStructuredSelection.length"
                v-on:submit="panelState.activateSelectionPanel()"
            />
        </div>
    </div>

    <div data-js="seatmap-back-action"
         v-bind:style="{ display: controlState.displayExitLayerButton ? '' : 'none' }"
         class="m-mobileControls__backButton">
        <ActionButton :icon-name="IconName.Arrow" :label="exitLevelLabel" v-on:clicked="layerExit"></ActionButton>
    </div>
</template>